var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('g',{class:{
    'segment-mask': true,
    'segment-mask--active': _vm.isHighlighted,
    'segment-mask--show-on-hover': _vm.showOnHover,
    [`segment-mask-${_vm.label}`]: true,
  },attrs:{"data-label":_vm.label},on:{"mouseenter":function($event){_vm.isHighlighted = true},"mouseleave":function($event){_vm.isHighlighted = false}}},[_c('polygon',{style:(_vm.polygonStyle),attrs:{"points":_vm.pointsString}}),_vm._v(" "),(_vm.showLabel)?_c('text',{staticClass:"segment-mask__label",style:(_vm.labelStyle),attrs:{"x":_vm.labelPosition.x,"y":_vm.labelPosition.y}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }